<!-- ---------------------------new design----------------------------  -->
<ejs-dialog [visible]="Data.alertVisible ==='confirm'" [isModal]="true" [width]="'auto'" [showCloseIcon]="false"
    [minHeight]="'auto'" (beforeClose)="closePopup()" class="custom-dialog">

    <div class="alert-box">
        <div>
            <img src="assets/vectors/alert-icon.svg" class="icon" alt="alertCross" />
        </div>
        <div class="alert-msg">
            {{ Data.alertMessage | translate }}
        </div>
        <div class="confirm-btn">
            <div>
                <button (click)="onConfirm()" class="figma-btn-blue"><span>{{'OK'|translate}}</span></button>
            </div>
            <div>
                <a (click)="closePopup()" class="clear-btn">{{'Cancel'|translate}}</a>
            </div>
        </div>
    </div>
</ejs-dialog>
<!-- ---------------------------error  popup----------------------------  -->
<ejs-dialog [visible]="Data.alertVisible === 'error'" [isModal]="true" [width]="'min(92vw, 420px)'" [showCloseIcon]="false"
    [minHeight]="'auto'" (beforeClose)="closePopup()" class="custom-dialog">

    <div class="alert-box align-items-center">
        <div>
            <img src="assets/vectors/alert-icon.svg" class="icon" alt="alertCross" />
        </div>
        <div class="alert-msg">
            <ng-container *ngFor="let line of (Data.alertMessage | translate | messageLines: true); trackBy: trackByLineIndex">
                <span>{{ line }}</span><br />
            </ng-container>
        </div>
        <div class="confirm-btn">
            <div>
                <button (click)="onConfirm()" class="figma-btn-blue">
                    <span>{{'OK' | translate}}</span>
                </button>
            </div>
        </div>
    </div>
</ejs-dialog>
<!-- ---------------------------legal updates and newsletter----------------------------  -->
<ejs-dialog [visible]="Data.alertVisible ==='legalUpdatesConfirmation'" [isModal]="true" [width]="'auto'"
    [showCloseIcon]="false" [minHeight]="'auto'" (beforeClose)="closePopup()" class="custom-dialog">

    <div class="alert-box">
        <div>
            <img src="assets/vectors/alert-icon.svg" class="icon" alt="alertCross" />
        </div>
        <div class="alert-msg">
            {{ Data.alertMessage | translate }}
        </div>
        <div class="confirm-btn">
            <div>
                <button (click)="onConfirm()" class="figma-btn-blue"><span>{{'OK'|translate}}</span></button>
            </div>
        </div>
    </div>
</ejs-dialog>
<!-- ---------------------------sub task details popup----------------------------  -->
<!-- <ejs-dialog *ngIf="Data.alertVisible=='yesNo'" [isModal]="true" [width]="'auto'" [showCloseIcon]="false"
    [minHeight]="'auto'" (beforeClose)="closePopup()" class="custom-dialog">

    <div class="alert-box">
        <div>
            <img src="assets/vectors/alert-icon.svg" class="icon" alt="alertCross" />
        </div>
        <div class="alert-msg">
            {{ Data.alertMessage | translate }}
        </div>
        <div class="col-md-12  ok-btn-confirm colpadding0  yesNo">
            <button (click)="onConfirmYes()" class="figma-btn-blue "><span>{{'YES'|translate}}</span></button>
            <button (click)="onConfirmNo()" class="figma-btn-blue"><span>{{'NO'|translate}}</span></button>
        </div>
    </div>
</ejs-dialog> -->
<!-- ---------------------------Change Password Alert Popup----------------------------  -->
<ejs-dialog *ngIf="Data.alertVisible=='changePassword'" [isModal]="true" [minHeight]="'284px'" [showCloseIcon]="false"
    [width]="'min(92vw, 352px)'" (beforeClose)="closePopup()" class="custom-dialog">

    <div class="password-alert-box">
        <div>
            <img src="assets/vectors/bell-icon.png" class="bell-icon" alt="alertCross" />
        </div>
        <div>
            <h4 class="f-label">{{'Alert'|translate}}</h4>
        </div>
        <div class="alert-msg">
            {{ Data.alertMessage | translate }}
        </div>
        <div class="confirm-btn">
            <div>
                <a (click)="onChangeNowClick()" class="clear-btn">{{'Change Now'|translate}}</a>
            </div>
            <div>
                <button (click)="onExtendNowClick()" class="figma-btn-blue">
                    <span>
                        {{'Extend Now'|translate}}
                    </span>
                </button>
            </div>
        </div>
    </div>
</ejs-dialog>
<!-- --------------------------- Password Extension Alert Popup------------------------------>
<ejs-dialog *ngIf="Data.alertVisible=='passwordExtension'" [isModal]="true" [minHeight]="'284px'"
    [showCloseIcon]="false" [width]="'min(92vw, 352px)'" (beforeClose)="closePopup()" class="custom-dialog">

    <div class="password-alert-box">
        <div>
            <img src="assets/vectors/bell-icon.png" class="bell-icon" alt="alertCross" />
        </div>
        <div>
            <h4 class="f-label">{{'Alert'|translate}}</h4>
        </div>
        <div class="alert-msg">
            {{ Data.alertMessage | translate }}
        </div>
        <div class="confirm-btn">
            <div>
                <button (click)="onCloseClick()"
                    class="figma-btn-blue btn-width"><span>{{'OK'|translate}}</span></button>
            </div>
        </div>
    </div>
</ejs-dialog>



<ejs-dialog id="password-dialog" #dialog *ngIf="Data.alertVisible=='password'" [width]="Width" [showCloseIcon]="false"
    (beforeClose)="closePopup()" class="custom-dialog" [height]="Height">
    <div class="row col-12 dialog-content ">
        <div class="arrow-svg colpadding0">
            <div class="col-12 image colpadding0">
                <label class="alert-label-text">{{'Alert'|translate}}</label>
            </div>
        </div>
        <div class="col-md-12 f-label alert-msg margin-top-ten">
            <h4 class="f-label">{{ Data.alertMessage | translate }}</h4>
        </div>
    </div>
    <div class="col-md-12  ok-btn-confirm colpadding0">
        <button (click)="closePopup()" class="figma-btn-blue "><span>{{'Change Now'|translate}}</span></button>
        <button (click)="onConfirm()" class="figma-btn-blue"><span>{{'Extend Now'|translate}}</span></button>
    </div>
</ejs-dialog>

<ejs-dialog id="switch-language-dialog" #dialog *ngIf="Data.alertVisible=='switchLanguage'" [width]="Width"
    [minHeight]="'250px'" [showCloseIcon]="true" (beforeClose)="closePopup()" class="custom-dialog" [height]="Height"
    [isModal]="true" [header]="'Select Language'|translate">

    <div class="row col-12 dialog-content">
        <div class="col-12 mt-3 radioButtons d-flex flex-column align-items-center">
            <div *ngFor="let lang of languages" class="radio-wrapper">
                <ejs-radiobutton [label]="lang.labelKey | translate" name="language" [value]="lang.value"
                    [checked]="selectedLanguage === lang.value" (change)="onLanguageChange(lang.value)">
                </ejs-radiobutton>
            </div>
        </div>

        <div *ngIf="showValidationMsg" class="text-danger mt-2 text-center validation-msg">
            {{'Please select a language'|translate}}
        </div>
    </div>

    <div class="col-md-12 ok-btn-confirm colpadding0 mt-3 text-center">
        <button class="figma-btn-blue" (click)="switchLanguage()">
            <span>{{'Switch Language'|translate}}</span>
        </button>
    </div>
</ejs-dialog>


<!-- ---------------------------my approvals---------------------------- -->
<ejs-dialog [visible]="Data.alertVisible === 'myApprovals'" [isModal]="true" [width]="'auto'" [showCloseIcon]="false"
    [minHeight]="'auto'" (beforeClose)="closePopup()" class="custom-dialog">

    <div class="alert-box">
        <div>
            <img src="assets/vectors/alert-icon.svg" class="icon" alt="alertCross" />
        </div>
        <div class="alert-msg">
            {{ Data.alertMessage | translate }}
        </div>
        <div class="confirm-btn">
            <div>
                <button (click)="onConfirm()" class="figma-btn-blue"><span>{{'OK'|translate}}</span></button>
            </div>
            <div>
                <a (click)="closePopup()" class="clear-btn">{{'Cancel'|translate}}</a>
            </div>
        </div>
    </div>
</ejs-dialog>
<!-- ---------------------------Success alert popup----------------------------  -->
<ejs-dialog [visible]="Data.alertVisible ==='success'" [isModal]="true" [width]="'auto'" [showCloseIcon]="false"
    [minHeight]="'auto'" (beforeClose)="closePopup()" (overlayClick)="closePopup()" class="custom-dialog">

    <div class="alert-box">
        <div>
            <img src="assets/vectors/success-tick.svg" class="icon" alt="alertCross" />
        </div>
        <div class="alert-msg">
            {{ Data.alertMessage | translate }}
        </div>
        <div class="confirm-btn">
            <!-- <div>
                <a (click)="closePopup()" class="clear-btn">Cancel</a>
            </div> -->
            <div>
                <button (click)="onConfirm()" class="figma-btn-blue"><span>{{'OK'|translate}}</span></button>
            </div>
        </div>
    </div>
</ejs-dialog>
<!-- ---------------------------Usage Report Condition----------------------------  -->
<ejs-dialog [visible]="Data.alertVisible ==='excelExport'" [isModal]="true" [width]="'min(92vw, 64rem)'" [showCloseIcon]="true"
    [minHeight]="'auto'" (beforeClose)="closePopup()" [header]="''" class="custom-dialog excel-custom-dialog">

    <div class="excel-alert-box">
        <!-- <div>
            <img src="assets/vectors/alert-icon.svg" class="icon" alt="alertCross" />
        </div> -->
        <div class="alert-msg">
            {{ Data.alertMessage | translate }}
        </div>
        <div class="excel-confirm-btn">
            <div>
                <button (click)="onConfirm()" class="figma-btn-blue yes-btn">
                    <span>
                        {{'Yes, Please sent it on my email'|translate}}
                    </span>
                </button>
            </div>
            <div>
                <a (click)="closePopup()" class="clear-btn no-btn">
                    {{'No, I will come back and download it'|translate}}
                </a>
            </div>
        </div>
    </div>
</ejs-dialog>
<!-- ---------------------------period change----------------------------  -->
<ejs-dialog [visible]="Data.alertVisible ==='confirmPeriodChange'" [isModal]="true" [width]="'min(92vw, 420px)'"
    [showCloseIcon]="false" [minHeight]="'auto'" (beforeClose)="closePopup()" class="custom-dialog period-change-dialog">

    <div class="period-change-box flex-direction-row">
        <div class="period-change-icon">
            <img src="assets/vectors/to-and-fro-icon.svg" alt="switch" />
        </div>
        <div class="period-change-box">
        <ng-container *ngIf="(Data.alertMessage | translate | messageLines) as periodLines">
            <div class="period-change-title">{{ periodLines[0] }}</div>
            <div class="period-change-desc">{{ periodLines[1] }}</div>
        </ng-container>
        <div class="period-change-actions">
            <button (click)="closePopup()" class="period-cancel-btn">{{'Cancel' | translate}}</button>
            <button (click)="onConfirm()" class="period-confirm-btn">{{'Yes, switch' | translate}}</button>
        </div>
        </div>
    </div>
</ejs-dialog>

<!-- ---------------------------Disclosure Popup----------------------------  -->

<ejs-dialog *ngIf="disclosureInformation.visible" [isModal]="true" [width]="'auto'" [showCloseIcon]="false"
    [minHeight]="'auto'" (beforeClose)="closePopup()" class="custom-dialog">

    <div class="alert-box-disclosure">
        <div class="dislosure-title">
            {{disclosureInformation.title}}
        </div>
        <div class="alert-msg">
            {{disclosureInformation.description}}
        </div>
        <div class="disclosure-btn-grp">
            <!-- <button (click)="onConfirmNoDisclosure()"  class="clear-btn">
                <span>
                    {{'NO' | translate}}
                </span>
            </button> -->
            <button (click)="onConfirmYesDisclosure()" class="figma-btn-blue auto-width">
                <span>
                    {{'Yes, I confirm' | translate}}
                </span>
            </button>
        </div>
    </div>
</ejs-dialog>